import { Link } from 'react-router-dom';
import { GOOGLE_REVIEW_COUNT } from '../../seo/companyFacts';
import './HomeHeroSection.css';

const HOME_HERO_BUSINESS_IMG_BASE = '/Images/home-hero-warehouse-new.jpg';

export default function HomeHeroSection() {
  return (
    <section className="home-hero-sfp" aria-labelledby="home-hero-heading">
      <div className="home-hero-sfp-container">
        
        {/* Left Column */}
        <div className="home-hero-sfp-left">
          <div className="home-hero-sfp-badge">
            <span className="home-hero-sfp-badge-dot" aria-hidden></span>
            PICK AND PACK • UK FULFILMENT
          </div>
          
          <h2 id="home-hero-heading" className="home-hero-sfp-title">
            UK Ecommerce <span style={{ color: '#1A44E5' }}>Pick and Pack Services</span> &amp; 3PL Fulfilment Logistics
          </h2>
          
          <p className="home-hero-sfp-sub">
            A trusted UK-based 3PL partner helping Amazon sellers, Shopify merchants and growing ecommerce brands store, pack and ship with confidence.
          </p>

          <div className="home-hero-aeo-summary">
            <div className="aeo-summary-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f58030" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
              <strong>Executive Summary</strong>
            </div>
            <div className="aeo-summary-body">
              Pick Pack Pro is a specialist 3PL partner designed for UK and international ecommerce brands, Amazon sellers, and Shopify merchants. We provide fast, compliant <Link to="/amazon-fba-prep-services">FBA prep</Link>, multi-channel pick and pack, and <a href="https://sell.amazon.co.uk/fulfilment-by-amazon" target="_blank" rel="noopener noreferrer nofollow">Amazon FBA</a> routing to help scaling businesses streamline their supply chain operations from our Milton Keynes hub.
            </div>
          </div>

          <div className="home-hero-sfp-rating" aria-label={`${GOOGLE_REVIEW_COUNT} Google reviews, 5.0 out of 5 stars`}>
            <div className="stars-wrapper">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#f5a623"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#f5a623"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#f5a623"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#f5a623"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#f5a623"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
            </div>
            <strong style={{marginLeft: "10px", color: "#0f172a", fontWeight: "700"}}>5.0</strong>
            <span style={{color: "#475569", marginLeft: "6px"}}>Google rating · <Link to="/our-reviews" style={{textDecoration: "underline", color: "#475569"}}>{GOOGLE_REVIEW_COUNT} verified reviews</Link></span>
          </div>

          <div className="home-hero-sfp-cta-row">
            <div className="cta-row-1">
              <Link to="/contact-fulfillment-services" className="hh-btn hh-btn-primary">
                Start your trial today <span className="arrow">→</span>
              </Link>
              <Link to="/case-studies" className="hh-btn hh-btn-outline">
                Success stories
              </Link>
            </div>
            <div className="cta-row-2">
              <Link to="/pricing-fulfilment-services" className="hh-btn hh-btn-ghost">
                View pricing
              </Link>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="home-hero-sfp-right">
          <div className="sfp-bg-image" style={{ backgroundImage: `url(${HOME_HERO_BUSINESS_IMG_BASE})` }}></div>
          <svg className="sfp-curve" viewBox="0 0 100 800" preserveAspectRatio="none" fill="#ffffff">
            <path d="M0,0 C80,200 40,600 0,800 Z" />
          </svg>

          <div className="sfp-floating-cards">
            <div className="sfp-vertical-line"></div>
            
            <div className="sfp-card">
              <div className="sfp-card-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
              </div>
              <div className="sfp-card-text">
                <strong>Same-day dispatch</strong>
                <span>Get orders out, faster.</span>
              </div>
            </div>
            
            <div className="sfp-card">
              <div className="sfp-card-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
              </div>
              <div className="sfp-card-text">
                <strong>Real-time inventory sync</strong>
                <span>Across all channels.</span>
              </div>
            </div>
            
            <div className="sfp-card">
              <div className="sfp-card-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1a44e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
              </div>
              <div className="sfp-card-text">
                <strong>FBA compliant preparation</strong>
                <span>To Amazon standards.</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

